import { render, staticRenderFns } from "./setting-swipe.vue?vue&type=template&id=6d865f79&scoped=true&"
import script from "./setting-swipe.vue?vue&type=script&lang=js&"
export * from "./setting-swipe.vue?vue&type=script&lang=js&"
import style0 from "./setting-swipe.vue?vue&type=style&index=0&id=6d865f79&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d865f79",
  null
  
)

export default component.exports